var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext } from "react";
import { DatagridConfigurable, List, TextField, useGetList, useNotify, useRefresh, } from "react-admin";
import { useTenantStore } from "../../providers/TenantContextProvider";
import { ActionsColumn } from "../../components/ActionButons";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Drawer } from "@mui/material";
import { EditRole } from "./EditRole";
import { ListActions } from "@/components/ListActions";
import { CreateRole } from "./CreateRole";
import { Dialog } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { DELETE_ROLE } from "@/queries/DeleteRole";
import { IPermissions } from "@/types/keycloak";
import { AuthContext } from "@/providers/AuthContextProvider";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
var OMIT_FIELDS = [];
export var ListRoles = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(false), openDeleteModal = _c[0], setOpenDeleteModal = _c[1];
    var _d = React.useState(false), openDrawer = _d[0], setOpenDrawer = _d[1];
    var _e = React.useState(undefined), recordId = _e[0], setRecordId = _e[1];
    var t = useTranslation().t;
    var _f = React.useState(), deleteId = _f[0], setDeleteId = _f[1];
    var _g = useGetList("permission", {
        filter: { tenant_id: tenantId },
    }), permissions = _g.data, total = _g.total, isLoading = _g.isLoading, error = _g.error, refetch = _g.refetch;
    var authContext = useContext(AuthContext);
    var canCreateRole = authContext.isAuthorized(true, authContext.tenantId, IPermissions.ROLE_CREATE);
    var deleteRole = useMutation(DELETE_ROLE)[0];
    var notify = useNotify();
    var refresh = useRefresh();
    var handleCloseCreateDrawer = function () {
        setRecordId(undefined);
        setOpenDrawer(false);
    };
    var handleCloseEditDrawer = function () {
        setOpen(false);
        setTimeout(function () {
            setRecordId(undefined);
        }, 400);
    };
    var editAction = function (id) {
        setRecordId(id);
        setOpen(true);
    };
    var deleteAction = function (id) {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var confirmDeleteAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteRole({
                            variables: {
                                tenantId: tenantId,
                                roleId: deleteId,
                            },
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    notify(t("usersAndRolesScreen.roles.notifications.deleteError"), { type: "error" });
                    console.log("Error deleting role: ".concat(error_1));
                    return [2 /*return*/];
                case 3:
                    notify(t("usersAndRolesScreen.roles.notifications.deleteSuccess"), { type: "success" });
                    setDeleteId(undefined);
                    refresh();
                    return [2 /*return*/];
            }
        });
    }); };
    var actions = [
        { icon: _jsx(EditIcon, {}), action: editAction },
        { icon: _jsx(DeleteIcon, {}), action: deleteAction },
    ];
    return (_jsxs(_Fragment, { children: [_jsxs(List, { resource: "role", actions: _jsx(ListActions, { withImport: false, withFilter: false, open: openDrawer, setOpen: setOpenDrawer, withComponent: canCreateRole, Component: _jsx(CreateRole, { close: handleCloseCreateDrawer, permissions: permissions }) }), filter: { tenant_id: tenantId }, aside: aside, children: [_jsxs(DatagridConfigurable, { header: ThreeStateDatagridHeader, omit: OMIT_FIELDS, bulkActionButtons: _jsx(_Fragment, {}), children: [_jsx(TextField, { source: "name" }), _jsx(TextField, { source: "id" }), _jsx(ActionsColumn, { actions: actions })] }), _jsx(Drawer, { anchor: "right", open: open, onClose: handleCloseEditDrawer, PaperProps: {
                            sx: { width: "40%" },
                        }, children: _jsx(EditRole, { id: recordId, close: handleCloseEditDrawer, permissions: permissions }) })] }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                }, children: t("usersAndRolesScreen.roles.delete.body") })] }));
};
